/**
 * Wire up a horizontal drag interaction: calls `onMove(clientX)` on every
 * pointer move until pointer up, while suppressing text selection and setting a
 * resize cursor on the body. Uses Pointer Events so it works for mouse, touch
 * and pen. Reusable by any resize handle / split divider.
 */
export const attachHorizontalDrag = (
	onMove: (clientX: number) => void,
	cursor: "col-resize" | "ew-resize" = "col-resize"
): void => {
	const move = (ev: PointerEvent) => onMove(ev.clientX);
	const up = () => {
		window.removeEventListener("pointermove", move);
		window.removeEventListener("pointerup", up);
		document.body.style.userSelect = "";
		document.body.style.cursor = "";
	};
	document.body.style.userSelect = "none";
	document.body.style.cursor = cursor;
	window.addEventListener("pointermove", move);
	window.addEventListener("pointerup", up);
};
